<template>
  <div>
    <div
      klickbox-edit-item="general"
      :klickbox-edit-label="$t('edit.canvas.general_styles')">
      <progress-bar v-if="boxConfig.progressbar.kind !== 'counter'"></progress-bar>
      <div class="kbx-content">
        <counter v-if="boxConfig.progressbar.kind === 'counter'"></counter>
        <title-preview></title-preview>
        <description></description>
        <button-redirect v-if="!stepActive.redirect_automatic"></button-redirect>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProgressBar from '../../progressbar/Main';
import TitlePreview from './../Title';
import Description from './../Description';
import ButtonRedirect from './Button';
import Counter from './../Counter';

export default {
  components: {
    ProgressBar,
    TitlePreview,
    Description,
    ButtonRedirect,
    Counter,
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
    stepActive: 'stepActive',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?b826348a
 **/